import { isAfter, set } from "date-fns"

// 15 october
const cutoffDate = set(new Date(), {
  month: 9,
  date: 15,
})
const currentYear = new Date().getFullYear()

export const marketingOperationCurrentYear = isAfter(new Date(), cutoffDate)
  ? currentYear + 1
  : currentYear
